module.exports = __webpack_public_path__ + "static/media/file-image.695a6194.svg";